import { Box, Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import LanguageIcon from '@mui/icons-material/Language';
import AddIcon from '@mui/icons-material/Add';
import WebhookForm from './WebhookForm';
import { useMutateWebhookHandler } from '../dataHandlers/mutateWebhookHandler';
import { usePermissions } from '../../../hooks/usePermissions';
import { useAccessDeniedMessage } from '../../../hooks/useAccessDeniedMessage';
import PermissionDeniedWrapper from '../../../components/PermissionDeniedWrapper';
import { CREATE_WEBHOOK_CONFIG } from '../../../constants/webhookPermissions';

const GlobalWebhookCreateSection = () => {
  const [openForm, setOpenForm] = useState(false);
  const { mutate } = useMutateWebhookHandler({});
  const { hasWebhookPermission } = usePermissions();
  const accessDeniedMessage = useAccessDeniedMessage();
  const canCreate = hasWebhookPermission(CREATE_WEBHOOK_CONFIG);

  const handleCreate = (payload) => {
    if (!canCreate) {
      return;
    }
    mutate({ isEdit: false, payload });
    setOpenForm(false);
  };

  return (
    <>
      <LanguageIcon fontSize="large" />
      <Typography fontWeight={600} fontSize={22} sx={{ color: '#fff' }}>
        No global webhook configured
      </Typography>
      <Typography width="50%" textAlign="center">
        Set up a global default endpoint to receive events for all organizations. Specific endpoints can be added later
        to route individual org events elsewhere.
      </Typography>
      <PermissionDeniedWrapper show={!canCreate} title={accessDeniedMessage}>
        <Button
          sx={{ mt: 2 }}
          variant="contained"
          startIcon={<AddIcon />}
          disabled={!canCreate}
          onClick={() => setOpenForm(true)}
        >
          Add Webhook
        </Button>
      </PermissionDeniedWrapper>
      <WebhookForm
        open={openForm}
        onClose={() => setOpenForm(false)}
        mode="create"
        onSubmit={handleCreate}
        isGlobal={true}
      />
    </>
  );
};

export default GlobalWebhookCreateSection;
